import { render } from "./ClMotion.vue?vue&type=template&id=3c089b40"
import script from "./ClMotion.vue?vue&type=script&lang=js"
export * from "./ClMotion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__